/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 29/07/13
 * Time: 17:10
 * To change this template use File | Settings | File Templates.
 */


angular.module('FlexyBeautyApp.services').factory('ReadOnlyBookingView', ["$log", "Period", "DaySrv", "ReadOnlyBookingServiceView", "BookingData",
    function ($log, Period, DaySrv, ReadOnlyBookingServiceView, BookingData) {

        var BookingView = function (booking, customerView) {
            this.bookingIndex = BookingData.getIndexOf(booking);
            this.label = null;
            this.price = 0;
            this.status = '';
            this.customerView = customerView;
            this.period = new Period();//period of booking
            this.date = null;
            //information selected by user
            // usePeriodStart : Store the fact that the adding action had been done -> next adding will use other rules
            this.bookingServicesView = []; // all linePeriods of the table selected

            if (booking)
                this.loadDataFrom(booking);
            else
                this.date = new Date();

        }
        BookingView.prototype.loadDataFrom = function (booking)//
        {
            if (booking) {
                this.label = booking.label;
                this.price = booking.price;
                this.status = booking.status;
                this.setPeriod(booking.period);
                if (booking.day)
                    this.date = DaySrv.getDateFromId(booking.day.id)
                else
                    this.date = new Date();

                var bsV;
                this.bookingServicesView = [];
                for (var i = 0; i < booking.bookingServices.length; i++) {
                    bsV = new ReadOnlyBookingServiceView(booking.bookingServices[i], i, this);
                    this.bookingServicesView.push(bsV);
                }
            }
        }

        BookingView.prototype.setPeriod = function (period) {
            if (period)
                this.period = new Period(period);
        }

        BookingView.prototype.getBookingServiceViewById = function (id) {
            var bs;
            for (var i = 0; i < this.bookingServicesView.length; i++) {
                bs = this.bookingServicesView[i].getModel();
                if (bs && bs.id == id)
                    return this.bookingServicesView[i];
            }
            return null;
        };


        BookingView.prototype.getModel = function () {
            if (this.bookingIndex != -1)
                return BookingData.getByIndex(this.bookingIndex);
            return null;
        }

        return BookingView;
    }])



// WEBPACK FOOTER //
// ./js/services/views/ReadOnlyBookingView.js